import { createListenerMiddleware } from '@reduxjs/toolkit'
import type { RootState } from '../root'
import { setManCode } from '../slices/configurationSlice'
import { _trackManCode } from '../slices/userDataSlice'

export const makeManCodeTracker = () => {
  const middleware = createListenerMiddleware<RootState>()
  middleware.startListening({
    matcher: setManCode.match,
    effect: (action, listenerApi) => {
      const state = listenerApi.getState()
      const { id, manCode } = action.payload
      const configuration = state.truckConfigurations.configurations[id]
      if (!configuration) {
        listenerApi.dispatch(
          _trackManCode({
            manCode: manCode,
          }),
        )
        return
      }

      const partPeriod = configuration.apiConfiguration.partPeriod
      const deliveryDate = configuration.apiConfiguration.desiredDealerDate
      const marketDenomination = configuration.marketDenomination
      const title = configuration.title

      listenerApi.dispatch(
        _trackManCode({
          manCode: manCode,
          deliveryDate,
          partPeriod,
          marketDenomination,
          title,
        }),
      )
    },
  })
  return middleware
}
